import type { LeaderboardEntry } from "@/types";
import { getLevelForXp } from "@/utils/levels";

interface LeaderboardTableProps {
  entries: LeaderboardEntry[];
  currentUserId?: string;
}

export function LeaderboardTable({ entries, currentUserId }: LeaderboardTableProps) {
  return (
    <div className="overflow-x-auto rounded-xl bg-white shadow-sm">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-100 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
            <th className="px-4 py-3">Rank</th>
            <th className="px-4 py-3">Player</th>
            <th className="px-4 py-3 text-right">XP</th>
            <th className="hidden px-4 py-3 text-right md:table-cell">Correct</th>
            <th className="px-4 py-3 text-right">Accuracy</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {entries.map((entry, index) => {
            const isCurrentUser = entry.userId === currentUserId;
            const accuracy = entry.totalAnswered > 0
              ? Math.round((entry.totalCorrect / entry.totalAnswered) * 100)
              : 0;
            const level = getLevelForXp(entry.totalXp);

            return (
              <tr
                key={entry.userId}
                className={isCurrentUser ? "bg-navy-50 font-medium" : ""}
              >
                <td className="px-4 py-3 text-sm">
                  {index < 3 ? (
                    <span className="text-lg">{["\uD83E\uDD47", "\uD83E\uDD48", "\uD83E\uDD49"][index]}</span>
                  ) : (
                    <span className="text-gray-500">{index + 1}</span>
                  )}
                </td>
                <td className="px-4 py-3">
                  <div className="text-sm text-gray-900">
                    {entry.displayName}
                    {isCurrentUser && (
                      <span className="ml-2 text-xs text-navy-500">(you)</span>
                    )}
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-gray-400">
                    <span className="flex h-4 w-4 items-center justify-center rounded-full bg-amber-100 text-[10px] font-bold text-amber-700">
                      {level.level}
                    </span>
                    {level.title}
                  </div>
                </td>
                <td className="px-4 py-3 text-right text-sm font-bold text-amber-600">
                  {entry.totalXp.toLocaleString()}
                </td>
                <td className="hidden px-4 py-3 text-right text-sm text-gray-700 md:table-cell">
                  {entry.totalCorrect}/{entry.totalAnswered}
                </td>
                <td className="px-4 py-3 text-right text-sm font-medium text-navy-700">
                  {accuracy}%
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
